<template>
  <v-card class="mx-auto mt-15">
    <v-container>
      <h2>Rules</h2>
      <v-spacer />
      <div
        style="display:inline-block"
        v-for="(data, index) in rules"
        :key="index"
      >
        <p>{{ data }}</p>
      </div>
    </v-container>
  </v-card>
</template>

<script>
import refs from "./firebase/refs";

export default {
  name: "Rules",
  props: {
    gameId: String,
  },
  async created() {
    await this.getRules();
  },
  methods: {
    async getRules() {
      var generalRules = this.getGeneralRules();
      generalRules.forEach((rule) => this.rules.push(rule));

      var gameConfigs = await this.getGameInfo();
      console.log("gameConfigs", gameConfigs);
      gameConfigs.forEach((rule) => this.rules.push(rule));
    },
    getGeneralRules() {
      var generalRules = [];
      generalRules.push(
        "Get your friends to guess the word at the top of the card without saying any of the four 'Taboo' words/phrases."
      );
      generalRules.push(
        "If someone guesses a direct translation of the word, it's correct!"
      );
      generalRules.push(
        "Using a direct translation of the word or any of the 'Taboo' words as a clue is not allowed."
      );
      return generalRules;
    },
    async getGameInfo() {
      var snapshot = await refs.gameConfigs(this.gameId).once("value");
      var rules = [];
      rules.push(
        "Each player will have " + snapshot.val().timer + " seconds per turn."
      );
      console.log("snapshot.val().passing", snapshot.val().passing);
      if (snapshot.val().passing) {
        rules.push(
          "You have the option to pass on a card, which will neither add nor remove from your score."
        );
      }
      return rules;
    },
  },
  data() {
    return {
      rules: [],
    };
  },
};
</script>
